var _ = require("lodash");

var modalMixin = {
    props: {
        show: {
            type: Boolean,
            default: false
        }
    },
    methods: {
        close() {
            this.$emit("close")
            if (typeof this.reset === 'function')
                this.reset();
        }
    }
};

var loadingMixin = {
    data() {
        return {
            isLoading: false
        }
    },
    methods: {
        showLoading() {
            this.isLoading = true
        },
        hideLoading(delay = 300) {
            _.delay(() => this.isLoading = false, delay)
        }
    }
};

var filterableMixin = {
    data() {
        return {
            filter: ""
        }
    },
    computed: {
        filteredData() {
            if (!this.filter || !this.filter.length)
                return this.data

            return this.data
                .filter((t) => {
                    var ok = false;
                    for (var key of Object.keys(t)) {
                        ok = _.lowerCase(t[key]).includes(_.lowerCase(this.filter));
                        if (ok) break;
                    }
                    return ok;
                });
        },
        filteredCountText() {
            if (this.data.length === this.filteredData.length)
                return `${this.data.length} entry(s) found.`;

            return `Showing ${this.filteredData.length} entry(s) (filtered from ${this.data.length})`
        }
    }
};

export {
    modalMixin, loadingMixin, filterableMixin
}
